/**
 * TanStack Query hooks for `awin-integration-api-key-publisher-id`.
 * Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	createCredential,
	listCredentials,
	revokeCredential,
	awinIntegrationApiKeyPublisherIdQueryKeys,
	type CreateCredentialBody,
	type CredentialRow,
	type ListCredentialsResponse,
	type RevokeResponse,
} from "./api";

export function useAwinIntegrationApiKeyPublisherIdList(): UseQueryResult<
	ListCredentialsResponse,
	Error
> {
	return useQuery({
		queryKey: awinIntegrationApiKeyPublisherIdQueryKeys.list(),
		queryFn: listCredentials,
	});
}

export function useAwinIntegrationApiKeyPublisherIdCreate(): UseMutationResult<
	CredentialRow,
	Error,
	CreateCredentialBody
> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: createCredential,
		onSuccess: () => {
			qc.invalidateQueries({
				queryKey: awinIntegrationApiKeyPublisherIdQueryKeys.all,
			});
		},
	});
}

export function useAwinIntegrationApiKeyPublisherIdDelete(): UseMutationResult<
	RevokeResponse,
	Error,
	string
> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: revokeCredential,
		onSuccess: () => {
			qc.invalidateQueries({
				queryKey: awinIntegrationApiKeyPublisherIdQueryKeys.all,
			});
		},
	});
}
